/* pg-blog.js — reading progress + auto TOC for article pages */
(function () {
  'use strict';

  const article = document.querySelector('.pg-article');
  if (!article) return;

  const progress = document.querySelector('.pg-progress');
  const content = article.querySelector('.pg-article__content');
  const tocList = article.querySelector('.pg-toc__list');

  // --- Auto-generate TOC from rendered H2s ---
  if (content && tocList) {
    const h2s = content.querySelectorAll('h2');
    if (h2s.length < 2) {
      // Not enough H2s to warrant a TOC — hide the sidebar entirely
      const toc = article.querySelector('.pg-toc');
      if (toc) toc.style.display = 'none';
    } else {
      const frag = document.createDocumentFragment();
      h2s.forEach((h, i) => {
        let id = h.id;
        if (!id) {
          id = 'pg-h-' + (h.textContent || '')
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '')
            .slice(0, 60) || 'pg-h-' + i;
          h.id = id;
        }
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        frag.appendChild(li);
      });
      tocList.appendChild(frag);

      // IntersectionObserver highlight
      const links = Array.from(tocList.querySelectorAll('a'));
      if ('IntersectionObserver' in window && links.length) {
        const linkById = {};
        links.forEach((a) => {
          const id = a.getAttribute('href').slice(1);
          linkById[id] = a;
        });
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              const id = e.target.id;
              const a = linkById[id];
              if (!a) return;
              if (e.isIntersecting) {
                links.forEach((l) => l.classList.remove('is-active'));
                a.classList.add('is-active');
              }
            });
          },
          { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
        );
        h2s.forEach((h) => io.observe(h));
      }
    }
  }

  // --- Reading progress bar ---
  if (progress && content) {
    let ticking = false;
    const update = () => {
      const rect = content.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      const scrolled = Math.max(0, Math.min(total, -rect.top));
      const pct = total > 0 ? (scrolled / total) * 100 : 0;
      progress.style.width = pct.toFixed(1) + '%';
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  // --- Copy link share button ---
  const copyBtns = article.querySelectorAll('[data-pg-copy]');
  copyBtns.forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      try {
        await navigator.clipboard.writeText(window.location.href);
        const original = btn.getAttribute('aria-label');
        btn.setAttribute('aria-label', 'Link copied');
        btn.classList.add('is-copied');
        setTimeout(() => {
          btn.setAttribute('aria-label', original);
          btn.classList.remove('is-copied');
        }, 1500);
      } catch (err) {
        /* noop */
      }
    });
  });
})();
